<template>
  <print-template :viewExtraFooter="true" :viewFooter="false">
    <table class="table-bordered c-24">
      <tr>
        <td colspan="5">Job Order Number:</td>
        <td colspan="7">{{ formModel.jo_no }}</td>
        <td colspan="5">Date Received:</td>
        <td colspan="7">
          {{ formModel.date_received | dateFormat("ddd, D MMM YYYY") }}
        </td>
      </tr>
      <tr>
        <td colspan="5">Customer/Airline</td>
        <td colspan="3">
          {{ formModel.customer_desc ? formModel.customer_desc.text : "" }}
        </td>
        <td colspan="3">CMM No.:</td>
        <td colspan="4">{{ masterlist.cmm.cmm_no }}</td>
        <td colspan="3">TSO Serial No.</td>
        <td colspan="6">{{ masterlist.tso_serial_no }}</td>
      </tr>
      <tr>
        <td colspan="5">IATA Code and Number</td>
        <td colspan="3">{{ masterlist.uld_id_code }}</td>
        <td colspan="3">CMM Date:</td>
        <td colspan="4">
          {{ masterlist.cmm.rev_date | dateFormat("MM-DD-YYYY") }}
        </td>
        <td colspan="3">ULD Part No.</td>
        <td colspan="6">{{ masterlist.part }}</td>
      </tr>
      <tr>
        <td colspan="5">Unit Type/Description</td>
        <td colspan="3">
          <label style="white-space: nowrap">{{
            masterlist.description
          }}</label>
        </td>
        <td colspan="3">Revision Status</td>
        <td colspan="4">
          {{ masterlist.cmm.rev_status }}
        </td>
        <td colspan="3">Manufacturer</td>
        <td colspan="6">{{ masterlist.manufacturer }}</td>
      </tr>
      <tr>
        <td rowspan="3" colspan="8" class="v-top" style="position: relative">
          <p class="mt-0 mb-0">Pre-Inspected by/Date</p>
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <img
              v-if="formModel.pre_approver.sign"
              :src="getImageSrc(formModel.pre_approver.sign)"
              alt="user e-signature"
              style=" max-height: 50px; display: inline-block"
            />
            <span
              style="position: absolute; bottom: 5px; display: flex; width: 100%; justify-content: center; "
              >{{ formModel.pre_approver.fullname
              }}<span class="d-inline-block ml-2">
                {{ formModel.pre_ins_date | dateFormat("D MMM YYYY") }}</span
              ></span>
          </div>
        </td>
        <td rowspan="3" colspan="7" class="v-top" style="position: relative">
          <p class="mt-0 mb-0">Final Inspected by/Date</p>
          <div
            v-if="formModel.status_id == 14"
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <img
              v-if="formModel.supervisor.sign"
              :src="getImageSrc(formModel.supervisor.sign)"
              alt="user e-signature"
              style=" max-height: 50px; display: inline-block"
            />
            <span
              style="position: absolute; bottom: 5px; display: flex; width: 100%; justify-content: center; "
              >{{ formModel.supervisor.fullname }}
              <span class="d-inline-block ml-2">{{
                formModel.job_completed | dateFormat("D MMM YYYY")
              }}</span></span
            >
          </div>
        </td>
        <td colspan="3">Manuf. Date:</td>
        <td colspan="3">
          {{ masterlist.manufacture_date | dateFormat("MM-DD-YYYY") }}
        </td>
      </tr>
      <tr>
        <td colspan="3">CRS Tracking No.:</td>
        <td colspan="3">
          {{ formModel.form_one ? formModel.form_one.form_one_id : "" }}
        </td>
      </tr>
      <tr>
        <td colspan="3">CRS Issue Date:</td>
        <td colspan="3">
          {{ formModel.job_completed | dateFormat("D MMM YYYY") }}
        </td>
      </tr>
    </table>

    <table class="table-bordered mb-1" id="damages">
      <tr>
        <td colspan="3">Description of Part/Panel</td>
        <td>Damage</td>
        <td>Action Taken</td>
        <td>Repaired By</td>
        <td colspan="3">Spare Parts Used</td>
        <td>QTY's</td>
        <td>Batch No.</td>
        <!-- <td>Parts Cost</td> -->
      </tr>
      <template v-for="(item, index) in damageList">
        <tr :key="'damage_r1' + index">
          <td
            :rowspan="item.spare_parts.length ? item.spare_parts.length : 1"
            colspan="3"
            class="v-top"
          >
            {{ index + 1 }}. {{ item.damage_part }}
          </td>
          <td
            :rowspan="item.spare_parts.length ? item.spare_parts.length : 1"
            class="v-top"
          >
            {{ getDamageDescription(item.damage) }}
          </td>
          <td
            :rowspan="item.spare_parts.length ? item.spare_parts.length : 1"
            class="v-top"
          >
            {{ item.action_desc ? item.action_desc.text : "" }}
          </td>
          <td
            :rowspan="item.spare_parts.length ? item.spare_parts.length : 1"
            class="v-top"
          >
            <div
              style="position: relative"
              v-if="item.mech_sign"
              class="d-flex justify-content-center"
            >
              <img
                :src="getImageSrc(item.mech_sign)"
                alt="user e-signature"
                style=" max-height: 30px; display: inline-block"
              />
              <span
                style="position: absolute; bottom: 0; display: flex; width: 100%; justify-content: center; "
                >{{ formModel.mechanic.fullname }}</span
              >
            </div>
            <div
              style="position: relative"
              v-if="item.welder"
              class="d-flex justify-content-center"
            >
              <img
                :src="getImageSrc(item.welder.sign)"
                alt="user e-signature"
                style=" max-height: 30px; display: inline-block"
              />
              <span
                style="position: absolute; bottom: 0; display: flex; width: 100%; justify-content: center; "
                >{{ item.welder.name }}</span
              >
            </div>
            <div
              style="position: relative"
              v-if="item.tailor"
              class="d-flex justify-content-center"
            >
              <img
                :src="getImageSrc(item.tailor.sign)"
                alt="user e-signature"
                style=" max-height: 30px; display: inline-block"
              />
              <span
                style="position: absolute; bottom: 0; display: flex; width: 100%; justify-content: center; "
                >{{ item.tailor.name }}</span
              >
            </div>
            <!-- {{ formModel.mechanic.username }} -->
          </td>
          <template v-if="item.spare_parts[0]">
            <td colspan="3">{{ item.spare_parts[0].parts_used.part_no }}</td>
            <td>{{ item.spare_parts[0].quantity }}</td>
            <td>{{ item.spare_parts[0].parts_used.batch_no }}</td>
            <!-- <td>{{ item.spare_parts[0].parts_used.final_price_aed }}</td> -->
          </template>
          <template v-else>
            <td colspan="3"></td>
            <td></td>
            <td></td>
            <!-- <td></td> -->
          </template>
        </tr>
        <template v-for="(spare, ctr) in item.spare_parts">
          <tr v-if="ctr != 0 && spare" :key="spare.id">
            <td colspan="3">{{ spare.parts_used.part_no }}</td>
            <td>{{ spare.quantity }}</td>
            <td>{{ spare.parts_used.batch_no }}</td>
            <!-- <td>{{ spare.parts_used.final_price_aed }}</td> -->
          </tr>
        </template>
      </template>
      <tr>
        <td colspan="5"></td>
        <td colspan="4">
          Total Repair Time: {{ formModel.total_repaired_time }}
        </td>
        <td colspan="3"></td>
      </tr>
    </table>

    <!-- <el-row class="mt-1 mb-1" :gutter="15">
      <template v-for="item in damages">
        <el-col
          v-for="(file, index) in item.files"
          :span="8"
          :key="`${file.url}_${index}`"
        >
          <img class="img-fluid" :src="getPath(file)" alt="img" />
        </el-col>
      </template>
    </el-row> -->
    <div class="masonry">
      <masonry :cols="3" :gutter="15">
        <template v-for="(item, ctr) in damages">
          <div v-for="(file, index) in item.files" :key="`img-${ctr}-${index}`">
            <img
              class="masonry__image"
              :src="getPath(file)"
              alt="img"
              height="200px"
            />
          </div>
        </template>
      </masonry>
    </div>
  </print-template>
</template>

<script>
import ULD from "@/models/ULD";
// import RepairCode from "@/models/RepairCode";
// import RepairLocation from "@/models/RepairLocation";
// import Masterlist from "@/models/Masterlist";
// import RepairStatus from "@/models/RepairStatus";
// import RepairDamage from "@/models/RepairDamage";
import PrintTemplate from "@/components/PrintTemplate.vue";
import moment from "moment";
export default {
  name: "repairULD_print",
  components: { PrintTemplate },
  data() {
    return {
      formModel: new ULD({ supervisor: {}, mechanic: {} }),
      damages: [],
      codes: [],
      locations: [],
      masterlist: { cmm: {} },
      repairStatus: [],
      customers: [],
      // damageDescriptions: ULD.damage_descriptions(),
      actions: ULD.action_taken(),
      isLoading: false
    };
  },
  computed: {
    damageDescriptions() {
      return this.$store.getters["uld/damageDescriptions"];
    },
    damageList() {
      let list = [...this.damages].sort((a, b) => a.id - b.id);
      return list;
    },
    currdate() {
      let str = moment()
        .format("DD MMM YYYY")
        .toLowerCase();
      return str;
    }
  },
  methods: {
    getDamageDescription(key) {
      let dd = this.damageDescriptions.find(o => o.id == key);
      if (dd) {
        return dd.name;
      }
      return "";
    },
    getImageSrc(img64) {
      return "data:image/jpg;base64," + img64;
    },
    getPart(value) {
      let obj = this.spareParts.find(o => o.id == value);
      if (obj) {
        return obj.name;
      }
      return "";
    },
    getPath(file) {
      return "data:image/jpg;base64," + file.path;
    },
    library() {
      this.customers = [];
      ULD.customers_data().then(list => {
        this.customers = list;
      });
    }
  },
  mounted() {
    this.library();
    let id = this.$route.params.id;
    if (id) {
      this.$store.dispatch("uld/fetchDamageDescriptions", { limit: 9999 });

      this.isLoading = true;
      ULD.list({ id: id }).then(data => {
        this.isLoading = false;
        let item = data.data[0];

        this.formModel = new ULD({
          id: item.id,
          jo_no: "TXJO-" + item.id.toString().padStart(5, 0),
          // code_id: item.code.id,
          location_id: item.location.id,
          masterlist_id: item.masterlist.id,
          status_id: item.status.id,
          type: item.type,
          description: item.description,
          date_received: item.date_received,
          job_completed: item.job_completed,
          mechanic: item.mechanic,
          supervisor: item.supervisor,
          pre_approver: item.pre_approver.id ? item.pre_approver : item.supervisor,
          status: item.status,
          form_one: item.form_one,
          labor: item.labor,
          pre_ins_date: item.pre_inspection_date ? item.pre_inspection_date : item.date_received,
          locked: item.locked ? true : false,
          materials: item.materials,
          damages: item.damages,
          customer: item.customer,
          customer_desc: this.customers.find(o => {
            return o.value == item.customer;
          }),
          time_rendered: item.time_rendered,
          time_rendered_hours: item.time_rendered
            ? parseInt(item.time_rendered.split(":")[0])
            : 0,
          time_rendered_minutes: item.time_rendered
            ? parseInt(item.time_rendered.split(":")[1])
            : 0
        });
        let repairTime = "";
        if (this.formModel.time_rendered_hours > 0)
          repairTime = this.$options.filters.pluralize(
            this.formModel.time_rendered_hours,
            "hour",
            { includeNumber: true }
          );
        if (repairTime) repairTime += " ";
        if (this.formModel.time_rendered_minutes > 0)
          repairTime += this.$options.filters.pluralize(
            this.formModel.time_rendered_minutes,
            "minute",
            { includeNumber: true }
          );

        this.formModel.total_repaired_time = repairTime;

        // Masterlist.fetch(this.formModel.masterlist_id).then(masterlist => {
        //   this.masterlist = masterlist;
        // });
        this.masterlist = item.masterlist;
        this.damages = [];
        for (let dmg of item.damages) {
          let params = {
            damage_id: dmg.id
          };
          ULD.get_damage_parts(params).then(resp => {
            if (resp) {
              let obj = {
                ...dmg,
                damage_desc: this.damageDescriptions.find(
                  o => o.value == dmg.damage
                ),
                action_desc: this.actions.find(
                  o => o.value == dmg.action_required
                ),
                files: []
              };
              resp.data[0].path.forEach(file => {
                obj.files.push({
                  path: file.path,
                  url: file.raw
                });
              });
              this.damages.push(obj);
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table-bordered {
  margin-top: -1px;
}
.table-bordered td {
  padding: 2px;
  font-size: 12px;
}
.v-top {
  vertical-align: top;
}
table.tiny td {
  font-size: 9px;
}
table.c-24 {
  td {
    width: calc(100% / 24);
    @for $i from 1 through 24 {
      &[colspan="#{$i}"] {
        width: calc((100% / 24) * #{$i});
      }
    }
  }
}
// img {
//   width: 100%;
//   max-height: 100px;
// }
.el-row .el-col {
  text-align: center;
}
#damages {
  tr {
    height: 13px;
  }
}
#codes {
  tr {
    td {
      padding-left: 8px;
      padding-right: 8px;
    }
  }
}
.masonry__image {
  object-fit: fill;
}
</style>
<style lang="scss">
@media print {
  #print-page {
    .header-space {
      height: 120px;
    }
    .footer-space {
      height: 30px;
    }
  }
}
</style>
